const Profile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M19.07 4.948C23.04 8.918 22.97 15.398 18.87 19.288C15.08 22.878 8.92999 22.878 5.12999 19.288C1.01999 15.398 0.949986 8.918 4.92999 4.948C8.82999 1.038 15.17 1.038 19.07 4.948Z"
        fill="#C1C1C1"
      />
      <path
        d="M12 18.32C10.42 18.32 8.84999 17.75 7.64999 16.62C7.50668 16.4827 7.42318 16.2945 7.41757 16.0962C7.41195 15.8978 7.48467 15.7052 7.61999 15.56C7.90999 15.26 8.37999 15.25 8.67999 15.53C10.51 17.26 13.49 17.26 15.32 15.53C15.62 15.25 16.1 15.26 16.38 15.56C16.66 15.86 16.65 16.34 16.35 16.62C15.15 17.75 13.58 18.32 12 18.32Z"
        fill="#C1C1C1"
      />
    </svg>
  );
};

export default Profile;
